export default "__VITE_ASSET__DqmGO71g__";